import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import TaxData from "../../data/TaxData";
import ProductData from "../../data/ProductData";
import localDB from "../../data/localDB";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {productDialog} from "../../actions/ProductDialogActions";
import {selectProduct} from "../../actions/ProductSelectActions";
import helpers from "../../functions/helpers";
import {providerDialog} from "../../actions/ProviderDialogAction";
import {selectProvider} from "../../actions/ProviderSelectAction";
import {categoryDialog} from "../../actions/CategoryDialogActions";
import CategoryDialog from "./CategoryDialog";
import {selectCategory} from "../../actions/CategorySelectActions";
import {taxDialog} from "../../actions/TaxDialogAction";
import {selectTax} from "../../actions/TaxSelectActions";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const c = require("../../constants");
const moneyMask = createNumberMask({
    prefix: '$',
});

class ProductDialog extends Component {

    constructor() {
        super();

        this.state = {
            data: {
                name: '',
                id: '',
                sale_price: 0,
                purchase_price: 0,
                tax_price: 0,
                category: null,
                provider: null,
                tax: null,
                active: true,
                sell_negative: true,
                show_in_menu: true,
                visible: false,
                product_type: '',
                stock: false,
                product_not_for_sale: false,
                barcode: '',
                min_stock: 0
            },
            categories: [],
            providers: [],
            taxes: [],
            name_error: false,
            price_error: false,
            purchase_price_error: false,
            tax_price_error: false,
            type_error: false,
            category_error: false
        };
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleBarCodeChange = this.handleBarCodeChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleProviderChange = this.handleProviderChange.bind(this);
        this.handleTaxChange = this.handleTaxChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleSalesPriceChange = this.handleSalesPriceChange.bind(this);
        this.handlePurchasePriceChange = this.handlePurchasePriceChange.bind(this);
        this.handleActive = this.handleActive.bind(this);
        this.handleVisible = this.handleVisible.bind(this);
        this.handleStock = this.handleStock.bind(this);
        this.handleMinStockChange = this.handleMinStockChange.bind(this)
    }

    componentDidMount() {
        this.initialFetch()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.product_dialog) {
            this.setState({data: nextProps.product_dialog.product});
        }
        if (nextProps.provider_select && nextProps.provider_select.id) {
            if(!this.state.providers.some( item => item.key === nextProps.provider_select.id)) {
                let text = nextProps.provider_select.factory ? `${nextProps.provider_select.full_name} - ${nextProps.provider_select.factory}` : nextProps.provider_select.full_name;
                let provider = {key: nextProps.provider_select.id, text, value: nextProps.provider_select.id};
                let providers = update(this.state, {providers: {$set: this.state.providers.push(provider)}});
                this.setState(providers);
                this.handleProviderChange(nextProps.provider_select.id);
            }
        }
        if (nextProps.category_select && nextProps.category_select.id) {
            if(!this.state.categories.some(item => item.key === nextProps.category_select.id)){
                let category = {key: nextProps.category_select.id, text: nextProps.category_select.name, value: nextProps.category_select.id};
                let categories = update(this.state, { categories: {$set: this.state.categories.push(category)}});
                this.setState(categories);
                this.handleCategoryChange(nextProps.category_select.id);
            }
        }
        if(nextProps.tax_select && nextProps.tax_select.id){
            if(!this.state.taxes.some(item => item.key === nextProps.tax_select.id )) {
                let text = `${nextProps.tax_select.name} - ${nextProps.tax_select.percentage}%`;
                let tax = {key: nextProps.tax_select.id, text, value: nextProps.tax_select.id};
                let taxes = update(this.state, {taxes: {$set: this.state.taxes.push(tax)}});
                this.setState(taxes);
                this.handleTaxChange(nextProps.tax_select.id);
            }
        }
    }

    initialFetch() {
        TaxData.listAll().then(taxes => {
            taxes.unshift({key: null, value: null, text: 'Ninguno'});
            this.setState({taxes});
        });

        let categories = localDB.get('categories');
        categories = categories.map(category => {return {key:category.id, value:category.id, text:category.name }});
        categories.unshift({key: null, value: null, text: 'Ninguna'});
        this.setState({categories});

        localDB.getDB('providers').then(providers => {
            providers = helpers.mapProviders(providers);
            providers.unshift({key: null, value: null, text: 'Ninguno'});
            this.setState({providers});
        });
    }


    handleNameChange = (event) => {
        let name = update(this.state, {
            data: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true})
        } else {
            this.setState({name_error: false})
        }
    };

    handleDescriptionChange = (event) => {
        let description = update(this.state, {
            data: {
                description: {
                    $set: event.target.value
                }
            }
        });
        this.setState(description);
    };

    handleMinStockChange = (event) => {
        let min_stock = update(this.state, {
            data: {
                min_stock: {
                    $set: event.target.value
                }
            }
        });
        this.setState(min_stock);
    };

    handleBarCodeChange = (event) => {
        let barcode = update(this.state, {
            data: {
                barcode: {
                    $set: event.target.value
                }
            }
        });
        this.setState(barcode);
    };

    handleActive = () => {
        let active = update(this.state, {
            data: {
                active: {
                    $set: !this.state.data.active
                }
            }
        });
        this.setState(active);
    };

    handleSellNegative = () => {
        let sell_negative = update(this.state, {
            data: {
                sell_negative: {
                    $set: !this.state.data.sell_negative
                }
            }
        });
        this.setState(sell_negative);
    };

    handleVisible = () => {
        let visible = update(this.state, {
            data: {
                visible: {
                    $set: !this.state.data.visible
                }
            }
        });
        this.setState(visible);
    };

    handleShowInMenu = () => {
        let visible = update(this.state, {
            data: {
                show_in_menu: {
                    $set: !this.state.data.show_in_menu
                }
            }
        });
        this.setState(visible);
    };

    handleStock = () => {
        let active = update(this.state, {
            data: {
                stock: {
                    $set: !this.state.data.stock
                }
            }
        });
        this.setState(active);
    };

    handleNotForSale = () => {
        let not_for_sale = update(this.state, {
            data: {
                not_for_sale: {
                    $set: !this.state.data.not_for_sale
                }
            }
        });
        this.setState(not_for_sale);
    };

    handleSalesPriceChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let sales_price = update(this.state, {
            data: {
                sale_price: {
                    $set: value
                }
            }
        });
        this.setState(sales_price);
        if (event.target.value.trim() === '') {
            this.setState({price_error: true})
        } else {
            this.setState({price_error: false})
        }
    };

    handlePurchasePriceChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let purchase_price = update(this.state, {
            data: {
                purchase_price: {
                    $set: value
                }
            }
        });
        this.setState(purchase_price);
        if (event.target.value.trim() === '') {
            this.setState({purchase_price_error: true})
        } else {
            this.setState({purchase_price_error: false})
        }
    };

    handleCategoryChange = (result) => {
        let category = update(this.state, {
            data: {
                category:  {$set: result}
            }
        });
        this.setState(category);
        this.setState({category_error: false});
    };

    handleProviderChange = (result) => {
        let provider = update(this.state, {
            data: {
                provider:  {$set: result},
            }
        });
        this.setState(provider);
    };

    handleTaxChange = (result) => {
        let tax = update(this.state, {
            data: {
                tax:  {$set: result}
            }
        });
        this.setState(tax);
    };

    handleTypeChange = (result) => {
        let name = update(this.state, {
            data: {
                product_type: {
                    $set: result
                }
            }
        });
        this.setState(name);
        this.setState({type_error: false})
    };

    handleAddProvider = (e, {value}) => {
        this.props.providerDialog({
            open: true,
            provider: {id: null, full_name: value, provider: null, factory: '', email: '', phone: '',  phone_prefix: '+57'}
        });
    };

    handleAddTax = (e, {value}) => {
        this.props.taxDialog({open: true, tax:{id:null, name:value, percentage:0}});
    };

    handleAddCategory = (e, {value}) => {
        this.props.categoryDialog({
            open: true,
            category: {id: null, name: value, active: true, image:null}
        });
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.data.name === '') {
            this.setState({name_error: true});
        } else if (this.state.data.category === '') {
            this.setState({category_error: true});
        } else if (this.state.data.product_type === '') {
            this.setState({type_error: true});
        } else if (this.state.data.sale_price === '') {
            this.setState({price_error: true});
        } else {
            this.setState({disabled_button: true});
            let data = this.state.data
            data.min_stock = data.min_stock === '' ? 0:data.min_stock
            data.variant_parent = this.props.product_dialog.is_variant ? this.props.product_dialog.variant_parent:null

            if (data.id) {
                ProductData.update(data, (res) => {
                    if (res.hasOwnProperty('product')) {
                        localDB.addOrUpdateDB('products', res['for_sale']);
                        this.dispatchData(res['product'], 'Producto Actualizado!');
                    }
                    else if (res.hasOwnProperty('error')) {
                        this.props.showToast({message: res.error, type: 'error'});
                        this.setState({disabled_button: false});
                    }
                    else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                        this.setState({disabled_button: false});
                    }
                });
            } else {
                ProductData.add(data, (res) => {
                    if (res !== null && res.hasOwnProperty('product')) {
                        localDB.addOrUpdateDB('products', res['for_sale']);
                        this.dispatchData(res['product'], 'Producto Agregado!');
                    }else if (res.hasOwnProperty('error')) {
                        this.props.showToast({message: res.error, type: 'error'});
                        this.setState({disabled_button: false});
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                        this.setState({disabled_button: false});
                    }
                });
            }
        }
    };

    handleClose = () => {
        this.setState({
            name_error: false,
            price_error: false,
            purchase_price_error: false,
            tax_price_error: false,
            type_error: false,
            category_error: false,
            data: {
                name: '',
                id: '',
                purchase_price: 0,
                sale_price: 0,
                tax_price: 0,
                category: {key: null, value: null},
                tax: {key: null, value: null, percentage: null},
                provider: {key: null, value: null},
                stock: false,
                active: true,
                product_type: '',
                min_stock: 0
            }
        });
        this.props.selectProvider({id: null, full_name: ''});
        this.props.selectCategory({id: null, name: '', active:true, image:null});
        this.props.productDialog({open: false, product: {id: null}, is_variant:false, variant_parent:null});
        this.props.selectTax({id: null, name: '', percentage:0});
    };

    dispatchData = (product, message) => {
        this.setState({disabled_button: false});
        this.props.selectProduct(product);
        this.props.selectProvider({id: null, full_name: ''});
        this.props.selectTax({id: null, name: '', percentage:0});
        this.props.selectCategory({id: null, name: '', active:true, image:null});
        this.props.productDialog({
            open: false, product: {
                id: null,
                name: '',
                sale_price: 0,
                purchase_price: 0,
                tax_price: 0,
                category: {},
                provider: {},
                tax: {},
                active: true,
                visible: false,
                product_type: '',
                stock: false,
                min_stock: 0
            },
            is_variant:false, variant_parent:null
        });
        this.props.showToast({message: message, type: 'success'});
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.product_dialog.open}>
                    <Modal.Header>{this.props.product_dialog.product.id ? 'Actualizar Producto' : 'Nuevo Producto'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid stackable>
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <Form.Input label='Nombre' placeholder='Nombre' value={this.state.data.name}
                                                        onChange={this.handleNameChange} error={this.state.name_error}/>
                                            {!this.props.product_dialog.is_variant ?<Form.Select label='Categoría' options={this.state.categories} search
                                                         value={this.state.data.category}
                                                         allowAdditions
                                                         additionLabel={<i style={{color: '#00D1C0'}}>Nueva Categoría: </i>}
                                                         onAddItem={this.handleAddCategory}
                                                         onChange={(e, {value}) => this.handleCategoryChange(value)}
                                                         placeholder='Categoría' error={this.state.category_error}/>:null}
                                            {!this.props.product_dialog.is_variant ? <Form.Select label='Tipo de Producto' options={c.PRODUCT_TYPES}
                                                         value={this.state.data.product_type}
                                                         onChange={(e, {value}) => this.handleTypeChange(value)}
                                                         placeholder='Tipo de Producto' error={this.state.type_error}/>:null}
                                            <Form.Checkbox label='Producto activo' checked={this.state.data.active}
                                                           onChange={this.handleActive}/>
                                            {!this.props.product_dialog.is_variant ? <Form.Checkbox label='Control de inventarios' checked={this.state.data.stock}
                                                           onChange={this.handleStock}/>:null}
                                            {!this.props.product_dialog.is_variant && this.state.data.stock ? <Form.Input label='Inventario Mínimo' placeholder='Inventarion Mínimo' type='number' value={this.state.data.min_stock}
                                                        onChange={this.handleMinStockChange} />:null}
                                            {this.state.data.stock ?<Form.Checkbox label='Vender en negativo' checked={this.state.data.sell_negative}
                                                           onChange={this.handleSellNegative}/>:null}
                                            {localDB.check_feature('product_not_for_sale') ? <Form.Checkbox label='No es para la venta' checked={this.state.data.not_for_sale} onChange={this.handleNotForSale}/>:null}
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Form.Input
                                                label='Precio de Compra o Producción'
                                                error={this.state.purchase_price_error}
                                                children={
                                                    <MaskedInput
                                                        mask={moneyMask}
                                                        value={this.state.data.purchase_price}
                                                        placeholder='Precio de Compra o Producción'
                                                        onChange={this.handlePurchasePriceChange}
                                                    />
                                                }
                                            />
                                            <Form.Input
                                                label='Precio de Venta (Impuesto Incluido)'
                                                error={this.state.price_error}
                                                children={
                                                    <MaskedInput
                                                        mask={moneyMask}
                                                        value={this.state.data.sale_price}
                                                        placeholder='Precio de Venta (Impuesto Incluido)'
                                                        onChange={this.handleSalesPriceChange}
                                                    />
                                                }
                                            />
                                            {!this.props.product_dialog.is_variant ? <Form.Select noResultsMessage='No hay resultados' label='Impuesto' search
                                                         options={this.state.taxes}
                                                         value={this.state.data.tax}
                                                         allowAdditions
                                                         additionLabel={<i style={{color: '#00D1C0'}}>Nuevo Impuesto: </i>}
                                                         onAddItem={this.handleAddTax}
                                                         onChange={(e, {value}) => this.handleTaxChange(value)}
                                                         placeholder='Impuesto'/>:null}
                                            {!this.props.product_dialog.is_variant ? <Form.Select noResultsMessage='No hay resultados' label='Proveedor' search
                                                         options={this.state.providers}
                                                         value={this.state.data.provider}
                                                         allowAdditions
                                                         additionLabel={<i style={{color: '#00D1C0'}}>Nuevo Proveedor: </i>}
                                                         onAddItem={this.handleAddProvider}
                                                         onChange={(e, {value}) => this.handleProviderChange(value)}
                                                         placeholder='Proveedor'/>:null}
                                            <Form.Input label='Código de Barras' placeholder='Código de Barras' value={this.state.data.barcode}
                                                        onChange={this.handleBarCodeChange} />
                                        </Grid.Column>
                                    </Grid.Row>
                                    {!this.props.product_dialog.is_variant ? <Grid.Row columns={1}>
                                        <Grid.Column>
                                            <Form.TextArea label='Descripción' placeholder='Descripción' value={this.state.data.description}
                                                        onChange={this.handleDescriptionChange}/>
                                        </Grid.Column>
                                    </Grid.Row>:null}
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' labelPosition='left' disabled={this.state.disabled_button}
                                loading={this.state.disabled_button} onClick={this.handleSubmit}
                                content={this.props.product_dialog.product.id ? 'Actualizar' : 'Guardar'}/>
                    </Modal.Actions>
                </Modal>
                <CategoryDialog />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        product_dialog: state.get('product_dialog'),
        provider_select: state.get('provider_select'),
        category_select: state.get('category_select'),
        tax_select: state.get('tax_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data) {
            dispatch(showToast(data))
        },
        productDialog(data) {
            dispatch(productDialog(data))
        },
        selectProduct(data) {
            dispatch(selectProduct(data))
        },
        selectTax(data){
            dispatch(selectTax(data))
        },
        selectProvider(data){
            dispatch(selectProvider(data))
        },
        selectCategory(data){
            dispatch(selectCategory(data))
        },
        categoryDialog(data){
            dispatch(categoryDialog(data))
        },
        providerDialog(data){
            dispatch(providerDialog(data))
        },
        taxDialog(data) {
            dispatch(taxDialog(data));
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductDialog);


// WEBPACK FOOTER //
// ./src/components/inventories/ProductDialog.js